import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../index.css";
import { registerLicense } from "@syncfusion/ej2-base";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import Spinner from "../../components/Spinner";
import trash from "../../assets/images/trash.svg";
import searchsmall from "../../assets/images/Search.svg";

import upload from "../../assets/images/uploadN.svg";
import closex from "../../assets/images/X.svg";
import { useLocation } from "react-router-dom";
import Modal from "react-modal";
import Alert from "../../assets/images/alert-circle.svg";
import "./DocumentUpload.css";
import frame from "../../assets/images/Frame-green.svg";

import {
  PdfViewerComponent,
  Toolbar,
  Magnification,
  Navigation,
  LinkAnnotation,
  BookmarkView,
  ThumbnailView,
  Print,
  TextSelection,
  TextSearch,
  Annotation,
  FormFields,
  FormDesigner,
  Inject,
} from "@syncfusion/ej2-react-pdfviewer";
import {
  ToolbarComponent,
  ItemsDirective,
  ItemDirective,
  ClickEventArgs,
} from "@syncfusion/ej2-react-navigations";
import { updateSampleSection } from "./sample-base";

const DocumentUpload = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;
  const pdfViewerRef = useRef(null);
  const toolbarRef = useRef(null);
  const [templateName, setTemplateName] = useState("");
  const [templates, setTemplates] = useState([]);
  const [templateEdit, setTemplateEdit] = useState(false);
  const [onboardingTemplateEdit, setOnboardingTemplateEdit] = useState(false);
  const [candidateEdit, setCandidateEdit] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [formFieldId, setFormFieldId] = useState();
  const [edited, setEdited] = useState(false);
  const [searchKey, setSearchKey] = useState(false);
  const [form, setForm] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [deleteStatus, setDeleteState] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [currentPageNumber, setCurrentPageNumber] = useState("1");
  const [current_page_number, setCurrent_page_number] = useState();
  const [fileName, setFileName] = useState("");
  // const [showTemplates,setShowTemplates] = useState(false)
  const [show, setShow] = useState(false);
  const [totalPageCount, setTotalPageCount] = useState("of 0");
  const [searchText, setSearchText] = useState("");
  const [iconPopup, setIconPopup] = useState();
  const [documentOpenState, setDocumentOpenState] = useState(false);
  const [candidateFormId, setCandidateFormId] = useState();
  const [candidateFormFieldId, setCandidateFormFieldId] = useState();

  const [loader, setLoader] = useState(false);
  let user = JSON.parse(localStorage.getItem("UserData"));
  registerLicense(
    "Ngo9BigBOggjHTQxAR8/V1NAaF5cWWJCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXxecXRQRWNcWEZ+WUo="
  );
  useEffect(() => {
    updateSampleSection();
    fetchTemplates();
  }, []);
  let toolbar;

  useEffect(() => {
    const inputElement = document.getElementById("currentPage");

    const currentPageClicked = () => {
      inputElement.select();
    };

    const onCurrentPageBoxKeypress = (event) => {
      const currentPageBox = document.getElementById("currentPage");

      if (
        (event.which < 48 || event.which > 57) &&
        event.which !== 8 &&
        event.which !== 13
      ) {
        event.preventDefault();
        return false;
      } else {
        const currentPageNumber = parseInt(currentPageBox.value);

        if (event.which === 13) {
          if (
            currentPageNumber > 0 &&
            currentPageNumber <= pdfViewerRef.current.pageCount
          ) {
            pdfViewerRef.current.navigation.goToPage(currentPageNumber);
          } else {
            currentPageBox.value =
              pdfViewerRef.current.currentPageNumber.toString();
          }
        }
        return true;
      }
    };

    if (inputElement) {
      inputElement.addEventListener("click", currentPageClicked);
      inputElement.addEventListener("keypress", onCurrentPageBoxKeypress);
      inputElement.value = currentPageNumber;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChange = () => {
    setCurrentPageNumber(pdfViewerRef.current.currentPageNumber.toString());
    setCurrent_page_number(pdfViewerRef.current.currentPageNumber.toString());
    updatePageNavigation();
  };

  const documentLoaded = () => {
    setDocumentOpenState(true);
    setCurrent_page_number(pdfViewerRef.current.currentPageNumber.toString());
    setTotalPageCount("of " + pdfViewerRef.current.pageCount);
    updatePageNavigation();
  };

  const openFile = () => {
    document.getElementById("fileUpload").click();
  };

  const updatePageNavigation = () => {
    if (pdfViewerRef.current.currentPageNumber === 1) {
      toolbarRef.current.enableItems(
        document.getElementById("previous_page").parentElement,
        false
      );
      toolbarRef.current.enableItems(
        document.getElementById("next_page").parentElement,
        true
      );
    } else if (
      pdfViewerRef.current.currentPageNumber === pdfViewerRef.current.pageCount
    ) {
      toolbarRef.current.enableItems(
        document.getElementById("previous_page").parentElement,
        true
      );
      toolbarRef.current.enableItems(
        document.getElementById("next_page").parentElement,
        false
      );
    } else {
      toolbarRef.current.enableItems(
        document.getElementById("previous_page").parentElement,
        true
      );
      toolbarRef.current.enableItems(
        document.getElementById("next_page").parentElement,
        true
      );
    }
  };

  const readFile = (evt) => {
    setTemplateName("");
    const uploadedFiles = evt.target.files;
    const uploadedFile = uploadedFiles[0];
    setFileName(uploadedFile.name);

    const reader = new FileReader();
    reader.onload = function () {
      const uploadedFileUrl = this.result;
      pdfViewerRef.current.load(uploadedFileUrl, null);
      pdfViewerRef.current.fileName = uploadedFile.name;

      // Ensure that the page count is retrieved after the PDF is loaded.
      const pageCountElement = document.getElementById("totalPage");
      if (pageCountElement) {
        setTemplateName("");
        // Make sure pdfViewerRef.current.pageCount is accurate.
        // pageCountElement.textContent = "of " + pdfViewerRef.current.pageCount;
        // setTotalPageCount("of " + pdfViewerRef.current.pageCount)
      }
    };

    // Start reading the PDF file after setting the onload callback.
    reader.readAsDataURL(uploadedFile);
  };

  const fetchTemplates = () => {
    const obj = {
      userid: user?.id,
      searchkey: searchKey,
    };
    ApiHelper.post(API.fetchOnboardingTemplates, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          setTemplates(resData.data.convertedDocuments);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const handleInputChange = (event) => {
    setTemplateName(event.target.value);
  };

  useEffect(() => {
    // Access and manipulate DOM elements after the component is mounted.
    const previousPageElement = document.getElementById("previous_page");
    const nextPageElement = document.getElementById("next_page");

    if (previousPageElement && nextPageElement) {
      // Ensure that the elements exist before trying to enable or disable them.
      toolbarRef.current.enableItems(previousPageElement.parentElement, true);
      toolbarRef.current.enableItems(nextPageElement.parentElement, true);
    }
  }, [pdfViewerRef, toolbarRef]);

  useEffect(() => {
    if (location.pathname === "/dashboard/onboarding/edit-pdf-template") {
      setLoader(true);
      setEdited(false);
      setOnboardingTemplateEdit(false);
      setTemplateEdit(true);
      console.log(state);
      setDocumentId(state?.item?.id);
      const obj = {
        documentid: state?.item?.id,
      };
      try {
        ApiHelper.post(API.getPreviewConvertedDocument, obj).then((result) => {
          const base64 = result.data.b64Doc;
          const templateName = result.data.data.title;
          setTemplateName(templateName);
          pdfViewerRef.current.load(base64);
          setLoader(false);
        });
      } catch (err) {
        console.log("err", err);
      }
    } else if (location.pathname === "/dashboard/onboarding/edit-pdf-form") {
      setLoader(true);
      setEdited(false);
      setTemplateEdit(false);
      setOnboardingTemplateEdit(true);
      console.log(state);
      // setDocumentId(state?.item?.id);
      // const obj = {
      //   documentid: state?.item?.id,
      // };
      // try {
      //   ApiHelper.post(API.getPreviewConvertedDocument, obj).then((result) => {
      //     const base64 = result.data.b64Doc;
      //     const templateName = result.data.data.title;
      //     setTemplateName(templateName);
      //     pdfViewerRef.current.load(base64);
      //     setLoader(false);
      //   });
      // } catch (err) {
      //   console.log("err", err);
      // }
      if (pdfViewerRef.current && state.item.file_buffer_encrypted_value) {
        setTemplateName(state.item.details.title);
        if (state.item.role) {
          const candidateFormId = state.item.details.id;
          setCandidateFormId(candidateFormId);
          const dataString = state.item.data;
          const dataObject = JSON.parse(dataString);
          const numberOnly = dataObject.formfieldid;
          setCandidateFormFieldId(numberOnly);
          if (state.item.role == "candidate") {
            // setCandidateEdit(true);
          }
        } else {
          // setEdited(true);
        }
        const inputString = state.item.data;
        const jsonObj = JSON.parse(inputString);
        const formfieldId = jsonObj.formfieldid;
        setFormFieldId(formfieldId);
        // Load the PDF document from the Base64 data
        pdfViewerRef.current.load(state.item.file_buffer_encrypted_value);
      }
    } else {
      if (state != null) {
        if (state && form) {
          setLoader(true);
          setEdited(false);
          setOnboardingTemplateEdit(false);
          setTemplateEdit(true);
          setDocumentId(form.id);
          const obj = {
            documentid: form.id,
          };
          try {
            ApiHelper.post(API.getPreviewConvertedDocument, obj).then(
              (result) => {
                const base64 = result.data.b64Doc;
                const templateName = result.data.data.title;
                setTemplateName(templateName);
                pdfViewerRef.current.load(base64);
                setLoader(false);
              }
            );
          } catch (err) {
            console.log("err", err);
          }
        } else {
          if (pdfViewerRef.current && state.item.file_buffer_encrypted_value) {
            setTemplateName(state.item.details.title);
            if (state.item.role) {
              const candidateFormId = state.item.details.id;
              setCandidateFormId(candidateFormId);
              const dataString = state.item.data;
              const dataObject = JSON.parse(dataString);
              const numberOnly = dataObject.formfieldid;
              setCandidateFormFieldId(numberOnly);
              if (state.item.role == "candidate") {
                setCandidateEdit(true);
              }
            } else {
              setEdited(true);
            }
            const inputString = state.item.data;
            const jsonObj = JSON.parse(inputString);
            const formfieldId = jsonObj.formfieldid;
            setFormFieldId(formfieldId);
            // Load the PDF document from the Base64 data
            pdfViewerRef.current.load(state.item.file_buffer_encrypted_value);
          }
        }
      } else if (form) {
        setLoader(true);
        setTemplateEdit(true);
        setDocumentId(form.id);
        const obj = {
          documentid: form.id,
        };
        try {
          ApiHelper.post(API.getPreviewConvertedDocument, obj).then(
            (result) => {
              const base64 = result.data.b64Doc;
              const templateName = result.data.data.title;
              setTemplateName(templateName);
              pdfViewerRef.current.load(base64);
              setLoader(false);
            }
          );
        } catch (err) {
          console.log("err", err);
        }
      }
    }
  }, [pdfViewerRef, state, form, location]);

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      searchkey: searchKey,
    };
    ApiHelper.post(API.fetchOnboardingTemplates, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          setTemplates(resData.data.convertedDocuments);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }, [searchKey]);

  const deleteFormTemplate = (id) => {
    setLoader(true);
    const obj = {
      documentid: id,
    };
    ApiHelper.post(API.deleteConvertDocument, obj)
      .then((resData) => {
        if (resData) {
          fetchTemplates();
          setDeleteModalOpen(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
    // deleteConvertDocument
  };

  function clickHandler(args) {
    switch (args.item.id) {
      case "file_Open":
        setDocumentOpenState(true);
        var fileInput = document.getElementById("fileUpload");
        fileInput.click();
        break;
      case "previous_page":
        pdfViewerRef.current.navigation.goToPreviousPage();
        break;
      case "next_page":
        pdfViewerRef.current.navigation.goToNextPage();
        break;
      case "print":
        pdfViewerRef.current.print.print();
        break;
      case "fit_to_page":
        pdfViewerRef.current.magnification.fitToPage();
        break;
      case "zoom_in":
        pdfViewerRef.current.magnification.zoomIn();
        break;
      case "zoom_out":
        pdfViewerRef.current.magnification.zoomOut();
        break;
      case "form_designer":
        var viewer = document.getElementById("container").ej2_instances[0];
        // viewer.isFormDesignerToolbarVisible = true;
        viewer.toolbarModule.showAnnotationToolbar(true);

        break;
    }
    if (args.item.properties.text == "Choose Templates") {
      setShow(true);
      setSearchKey("");
    } else if (args.item.properties.text == "Save") {
      if (documentOpenState || edited || templateEdit || candidateEdit) {
        if (templateName != "") {
          console.log("DocumentOpenState", documentOpenState);

          setLoader(true);
          var viewer = document.getElementById("container").ej2_instances[0];
          const fileName = viewer.fileName;
          var data;
          viewer.saveAsBlob().then(function (value) {
            data = value;
            var reader = new FileReader();
            reader.onloadend = function () {
              if (reader.readyState === FileReader.DONE) {
                var base64Data = reader.result;
                const formData = new FormData();
                formData.append("filebufferencrypted", base64Data);
                if (candidateEdit) {
                  formData.append("formid", candidateFormId);
                  formData.append("formfieldid", candidateFormFieldId);
                } else {
                  formData.append("documentid", documentId);
                  formData.append("formfieldid", formFieldId);
                  formData.append("title", templateName);
                  formData.append("subtitle", "converted document");
                  formData.append("userid", user.id);
                }

                ApiHelper.post(
                  edited
                    ? API.onboardingUpdateSectionConvertedDocument
                    : candidateEdit
                    ? API.applicantsEditConvertedDocument
                    : templateEdit
                    ? API.saveConvertDocumentEdit
                    : onboardingTemplateEdit
                    ? API.onboardingUpdateSectionTemplateConvertedDocument
                    : API.saveConvertDocument,
                  formData
                )
                  .then((res) => {
                    if (res) {
                      if (
                        location.pathname ===
                        "/dashboard/onboarding/edit-pdf-template"
                      ) {
                        navigate("/dashboard/onboarding/templates");
                      }
                      if (
                        location.pathname ===
                        "/dashboard/onboarding/edit-pdf-form"
                      ) {
                        navigate(
                          "/dashboard/onboarding/edit-onboarding-template"
                        );
                      }
                      handleAccordionClick();
                      setCurrent_page_number("");
                      setTotalPageCount("of 0");
                      setLoader(false);
                      setIconPopup(frame);
                      setModalIsOpen(true);
                      setErrorValue("File saved successfully");
                      viewer.unload();
                      setTemplateName("");
                      setDocumentOpenState(false);
                      // alert("file save successfully");
                      if (edited) {
                        navigate("/dashboard/onboarding/edit-forms");
                      }
                    } else {
                      setIconPopup(Alert);
                      setModalIsOpen(true);
                      setErrorValue("Error");
                      // alert("Error");
                    }
                  })
                  .catch((err) => {
                    console.log("err", err);
                  });
              }
            };
            reader.readAsDataURL(data);
          });
        } else {
          setIconPopup(Alert);
          setModalIsOpen(true);
          setErrorValue("Document name cannot be empty");
          // alert("Template name cannot be empty");
        }
      } else {
        setIconPopup(Alert);
        setModalIsOpen(true);
        setErrorValue("Please select a documet to save");
      }
    }
  }

  const handleAccordionClick = () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      searchkey: searchKey,
    };
    ApiHelper.post(API.fetchOnboardingTemplates, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          setTemplates(resData.data.convertedDocuments);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  function closeModal() {
    setModalIsOpen(false);
    setDeleteModalOpen(false);
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  const customStyles_save = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      maxWidth: "500px",
      width: "100%",
      marginRight: "0%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  const customStyles_dlt = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      maxWidth: "500px",
      width: "100%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  function template() {
    return (
      <div>
        <span className="e-pv-total-page-number" id="totalPage">
          {totalPageCount}
        </span>
      </div>
    );
  }
  function inputTemplate() {
    return (
      <div>
        <input
          type="text"
          className="e-input-group e-pv-current-page-number"
          id="currentPage"
          value={current_page_number}
        />
      </div>
    );
  }

  // const handleSearchInputChange = (value)=>{
  //   console.log('value---------',value);
  //   setSearchText(value)
  //   pdfViewerRef.current.textSearchModule.searchText(searchText);
  // }

  useEffect(() => {
    pdfViewerRef.current.textSearchModule.searchText(searchText);
  }, [searchText]);

  // const searchTemplate = ()=>{
  //   return(
  //     <div>
  //   <input
  //       type="text"
  //       id="searchInput"
  //       value={searchText}
  //       placeholder="Search..."
  //       onChange={e => handleSearchInputChange(e.target.value)}
  //       />
  // </div>
  //   )
  // }

  const inputBlurHandler = () => {
    console.log("searchText", searchText);
    pdfViewerRef.current.textSearchModule.searchText(searchText);
  };

  function nextTextSearch() {
    pdfViewerRef.current.textSearchModule.searchNext();
  }

  return (
    <div className="sidebar_open fixed-side" style={{ height: "100" }}>
      <div className="control-section"></div>
      <div className="action-itms full-drp wrapAlign mt-2 mb-3">
        <div className="wraper txtAlgn">
          <div>
            <div className="hd-can create-form-wrp box-height">
              <h4 className="mainHead">Convert PDF</h4>
              <p className="subHead">
                Convert any document into a fillable PDF.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="doct-upload-div">
        <div className="doct-name-save-bttn">
          <div className="form-floating doc_form ">
            <input
              type="text"
              className="form-control"
              placeholder="templateName"
              id="templateName"
              value={templateName}
              onChange={handleInputChange}
            />
            <label htmlFor="templateName">Document Name</label>
          </div>
          {/* <div className="form-floating doc_form ">
          <input
        type="text"
        id="searchInput"
        defaultValue={searchText}
        placeholder="Search..."
        onChange={e => handleSearchInputChange(e.target.value)}
        onBlur={inputBlurHandler}
      />
          </div> */}
        </div>

        <Modal
          isOpen={modalIsOpen}
          // onRequestClose={closeModal}
          style={customStyles_save}
          contentLabel="Example Modal"
        >
          <div className="modal-width savePopus">
            <div class="modal-header">
              <h4 class="modal-title d-flex align-items-center">
                <img
                  src={iconPopup}
                  alt="copy"
                  className="create-icon mb-0 me-2"
                />{" "}
                Message
              </h4>
              <button onClick={closeModal} className="modal-close">
                {" "}
                <img
                  src={closex}
                  alt="copy"
                  className="create-icon mb-0 me-2"
                />
              </button>
            </div>

            <div className="modal-delect-text txtFonts">{errorValue}</div>
            <div
              class="modal-footer footer-marg "
              style={{ marginTop: "-20px;" }}
            >
              <button
                type="button"
                class="yes-btn rounded p-2"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
        <Modal isOpen={show}>
          <div>
            <div className="modal-header mb-0">
              <h5 className="modal-title">Choose File</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => {
                  setShow(false);
                }}
              ></button>
            </div>

            <div className="modal-body wraper" style={{ height: "400px" }}>
              <div className="serchField mb-2 col-lg-5 pl-0 pt-0">
                <img src={searchsmall} alt="test" className="serc_icon" />
                <input
                  type="text"
                  className="sercInp"
                  placeholder="Search File Library..."
                  onChange={(e) => {
                    setSearchKey(e.target.value);
                  }}
                />
              </div>

              <div className="detail-tabs">
                {/* <div className="under-line"></div> */}
                <div className="wraper scrlHe-tab scroll1 mb-3">
                  {templates?.length > 0 ? (
                    templates.map((item) => (
                      <div className="wraper listTmplt alignDiv" key={item.id}>
                        <a
                          className="create-comp"
                          onClick={() => {
                            setForm(item);
                            setShow(false);
                          }}
                        >
                          <h6 className="create-comp-text">{item.title}</h6>
                        </a>
                        <span
                          className="icon-dele"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent event propagation
                            setModalData({
                              itemId: item.id,
                              itemName: item.title,
                            });
                            setDeleteModalOpen(true);
                          }}
                          style={{ cursor: "delete" }}
                        >
                          <img src={trash} alt="trash" className="dele-icon" />
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="create-comp-popup-text-heading-not-found">
                      No Templates
                    </div>
                  )}
                </div>{" "}
              </div>
            </div>
            {/* <div className="modal-footer footer-marg"> */}
            {/* <button type="button" className="btn btn-primary Cancel-pop" onClick={() => { setShowOnboardingTemplates(false); setSearchKey('') }}>Cancel</button> */}
            {/* <button type="button" className="btn btn-primary Add-pop mx-3" onClick={() => { importTemplate() }}>Save</button> */}
            {/* </div> */}
          </div>
        </Modal>

        <Modal
          isOpen={deleteModalOpen}
          onRequestClose={closeModal}
          style={customStyles_dlt}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Delete Template
            </h2>

            <button onClick={closeModal} className="modal-close">
              {" "}
              <img src={closex} alt="copy" className="create-icon mb-0 me-2" />
            </button>
            <hr />
            <div className="modal-delect-text txtFonts">
              Are you sure you want to delete {modalData?.itemName}?
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              <button
                className="yes-btn rounded p-2"
                onClick={() => {
                  deleteFormTemplate(modalData.itemId);
                }}
              >
                {" "}
                Yes{" "}
              </button>
              <p className="cancel-bttn" onClick={closeModal}>
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
        <div className="center-div">
          <div className="control-section doct-divz">
            {/* <div className="e-pdf-toolbar">
            <ToolbarComponent
              ref={(scope) => {
                toolbar = scope;
              }}
              clicked={clickHandler.bind(this)}
            >
              <ItemsDirective>
                <ItemDirective
                  text="Choose Templates"
                  tooltipText="Choose Templates"
                  id="chooseTemplates"
                  align="Center"
                ></ItemDirective>
                <ItemDirective
                  text="Save"
                  tooltipText="Save"
                  id="download"
                  align="Right"
                ></ItemDirective>
              </ItemsDirective>
            </ToolbarComponent>
          </div> */}
            <div className="e-pdf-toolbar custIcons bottom-space">
              <ToolbarComponent
                ref={toolbarRef}
                clicked={clickHandler.bind(this)}
              >
                <ItemsDirective>
                  <ItemDirective
                    text="Upload Document"
                    id="file_Open"
                    tooltipText="Open"
                  ></ItemDirective>
                  <ItemDirective
                    text="Choose Templates"
                    id="chooseTemplates"
                    tooltipText="Open"
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-previous-page-navigation-icon"
                    id="previous_page"
                    tooltipText="Previous Page"
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-next-page-navigation-icon"
                    id="next_page"
                    tooltipText="Next Page"
                  ></ItemDirective>
                  <ItemDirective
                    template={inputTemplate}
                    tooltipText="Page Number"
                    type="Input"
                  ></ItemDirective>
                  <ItemDirective
                    template={template}
                    tooltipText="Page Number"
                    id="page-no-border"
                  ></ItemDirective>

                  {/*<ItemDirective
                  prefixIcon="e-pv-print-document-icon"
                  tooltipText="Print"
                  id="print"
                ></ItemDirective>
                <ItemDirective
                  prefixIcon="e-pv-download-document-icon"
                  tooltipText="Download"
                  id="download"
                ></ItemDirective>*/}

                  <ItemDirective
                    prefixIcon="e-pv-zoom-out-sample"
                    id="zoom_out"
                    tooltipText="Zoom out"
                  ></ItemDirective>
                  {/* <ItemDirective prefixIcon="e-pv-fit-page" id='fit_to_page' tooltipText="Fit to page" ></ItemDirective> */}
                  <ItemDirective
                    prefixIcon="e-pv-zoom-in-icon"
                    id="zoom_in"
                    tooltipText="Zoom in"
                  ></ItemDirective>
                  <ItemDirective
                    text="Insert Field"
                    tooltipText="form_designer"
                    id="form_designer"
                  ></ItemDirective>

                  {/* <ItemDirective
                  align="Right"
                    template={searchTemplate}
                  ></ItemDirective> */}
                  <ItemDirective
                    text="Save"
                    tooltipText="Save"
                    id="download"
                    align="Right"
                  ></ItemDirective>
                  {/* <ItemDirective text="form fields" tooltipText="Save" id="form_fields" align="Right"></ItemDirective> */}
                </ItemsDirective>
              </ToolbarComponent>
            </div>

            <PdfViewerComponent
              id="container"
              //serviceUrl="http://208.109.14.7/pdfviewer"
              serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/pdfviewer"
              className="pdfHeight_limit"
              showNotificationDialog={false}
              enableToolbar={false}
              isFormDesignerToolbarVisible={true}
              ref={pdfViewerRef}
              documentLoad={documentLoaded}
              pageChange={onPageChange}
              toolbarSettings={{
                showTooltip: true,
                toolbarItems: [
                  "OpenOption",
                  "PageNavigationTool",
                  "MagnificationTool",
                  "AnnotationEditTool",
                  "FormDesignerEditTool",
                  "SearchOption",
                ],
                // type:'MultiRow'
              }}
            >
              <Inject
                services={[
                  Toolbar,
                  Magnification,
                  Navigation,
                  LinkAnnotation,
                  BookmarkView,
                  ThumbnailView,
                  Print,
                  TextSelection,
                  TextSearch,
                  Annotation,
                  FormFields,
                  FormDesigner,
                ]}
              />
            </PdfViewerComponent>
            <input
              type="file"
              id="fileUpload"
              accept=".pdf"
              onChange={readFile.bind(this)}
            />
          </div>
          {documentOpenState == false ? (
            <div class="d-flex justify-content-center bttns-div-center">
              <div className="align-div">
                <p className="center-div-top-text">Convert PDF is empty.</p>

                <button class="btn btn-default center-bttns" onClick={openFile}>
                  {" "}
                  <img src={upload} alt="test" className="upload-imags" />
                  Upload Document
                </button>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
        {loader && <Spinner />}
      </div>
    </div>
  );
};

export default DocumentUpload;
